var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgViewListOutline20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 5C17 3.896 16.104 3 15 3H5C3.896 3 3 3.896 3 5V15C3 16.104 3.896 17 5 17H15C16.104 17 17 16.104 17 15V5ZM15 5H5V7H15V5ZM5 9H15V11H5V9ZM15 13H5V15H15V13Z",
  fill: "currentColor"
})));
export { SvgViewListOutline20 as ReactComponent };